module.exports = __webpack_public_path__ + "img/DE00356.b594a790.png";